import { apiFetch } from './client';
import type { Page } from './discover';

/** The five things the specification says are worth telling somebody about. */
export type NotificationKind =
  'NEW_FOLLOWER' | 'LIKE' | 'COMMENT' | 'MODERATION_APPROVED' | 'MODERATION_REJECTED';

export interface Notification {
  id: string;
  kind: NotificationKind;
  /** What happened, and the detail — in the backend's words, not ours. */
  title: string;
  body: string;
  /** Where to go to see it. Empty when there is nowhere useful. */
  link: string;
  actor: { handle: string; display_name: string } | null;
  post: string | null;
  is_read: boolean;
  created_at: string;
}

export interface Inbox extends Page<Notification> {
  unread: number;
}

export async function listNotifications(page = 1): Promise<Inbox> {
  return apiFetch<Inbox>(`/notifications${page > 1 ? `?page=${page}` : ''}`);
}

/** The one question a badge asks, and the cheapest way to ask it. */
export async function unreadCount(): Promise<number> {
  const body = await apiFetch<{ unread: number }>('/notifications/summary');
  return body.unread;
}

/** Mark the ones named read, or all of them when nothing is named. */
export async function markRead(ids?: string[]): Promise<{ marked: number; unread: number }> {
  return apiFetch<{ marked: number; unread: number }>('/notifications/read', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(ids ? { ids } : {}),
  });
}
